import popupController from '../popup-controller';
import {VacancyApplyHandler} from '../../vacancy/vacancy-apply-handler';

class PopupVacancyApply {
    options = {
        actionUriAttribute: 'data-action-uri',
    };

    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.element = element;
        this.onClick = this.onClick.bind(this);
    }

    setup() {
        this.attachEventListeners();
    }

    destroy() {
        this.detachEventListeners();
        this.element = null;
    }

    attachEventListeners() {
        this.element.addEventListener('click', this.onClick);
    }

    detachEventListeners() {
        this.element.removeEventListener('click', this.onClick);
    }

    /**
     * @param {MouseEvent} e
     */
    onClick(e) {
        if (!(e.target instanceof HTMLAnchorElement)) {
            return;
        }

        if (!e.target.href.startsWith('mailto:')) {
            return;
        }

        e.preventDefault();
        this.handleVacancyApply(e.target.href);
    }

    async handleVacancyApply(email) {
        const handler = new VacancyApplyHandler(popupController.getPopup(), email);

        await handler.applyToVacancy(
            this.element.getAttribute(this.options.actionUriAttribute),
        );
    }
}

export default function (element) {
    const instance = new PopupVacancyApply(element);
    instance.setup();
    return instance;
}
